module.exports = __webpack_public_path__ + "img/logo_uciteljski.b45879a0.png";